import React from 'react';
import styles from './SilentPicker.module.scss';
import { PickerItem as PickerItemType } from './types';

interface PickerItemProps {
  item: PickerItemType;
  isSelected: boolean;
  isFocused: boolean;
  onSelect: (item: PickerItemType, sectionLabel?: string) => void;
  onKeyDown: (
    event: React.KeyboardEvent,
    item: PickerItemType,
    sectionLabel?: string
  ) => void;
  sectionLabel?: string;
}

export function PickerItem({
  item,
  isSelected,
  isFocused,
  onSelect,
  onKeyDown,
  sectionLabel
}: PickerItemProps) {
  // Format label with comment count if present and greater than 0
  const displayLabel =
    item.commentCount && item.commentCount > 0
      ? `${item.label} (${item.commentCount})`
      : item.label;

  return (
    <li
      className={`${styles['spectrum-picker-item']} ${
        isSelected ? styles['is-selected'] : ''
      } ${isFocused ? styles['is-focused'] : ''}`}
      role="option"
      aria-selected={isSelected}
      tabIndex={-1}
      data-item-id={item.id}
      onClick={() => onSelect(item, sectionLabel)}
      onKeyDown={e => onKeyDown(e, item, sectionLabel)}
    >
      <span className={styles['spectrum-picker-item-label']}>
        {displayLabel}
      </span>
      <span
        className={styles['spectrum-picker-checkmark']}
        aria-hidden="true"
        style={{ opacity: isSelected ? 1 : 0 }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M16.1483 5.46078L7.14828 14.4608C7.09604 14.5131 7.034 14.5546 6.96572 14.5829C6.89743 14.6112 6.82423 14.6258 6.75031 14.6258C6.67639 14.6258 6.6032 14.6112 6.53491 14.5829C6.46662 14.5546 6.40459 14.5131 6.35234 14.4608L2.41484 10.5233C2.3093 10.4177 2.25 10.2746 2.25 10.1253C2.25 9.97605 2.3093 9.83289 2.41484 9.72734C2.52039 9.6218 2.66355 9.5625 2.81281 9.5625C2.96208 9.5625 3.10523 9.6218 3.21078 9.72734L6.75031 13.2676L15.3523 4.66484C15.4579 4.5593 15.601 4.5 15.7503 4.5C15.8996 4.5 16.0427 4.5593 16.1483 4.66484C16.2538 4.77039 16.3131 4.91355 16.3131 5.06281C16.3131 5.21208 16.2538 5.35523 16.1483 5.46078Z"
            fill="#222222"
          />
        </svg>
      </span>
    </li>
  );
}
